<template>
  <div id="joinCompany">
    <!-- 头部 -->
    <join-header></join-header>
    <div class="bodyRow">
      <div class="titleRow">
        <img src="../../assets/image/icon_qy@2x.png" alt />
        <span>企业</span>
      </div>
      <div class="infoRow">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <!-- 1我加入的企业 -->
          <el-tab-pane label="我加入的企业" name="first">
            <div class="searchRow">
              <div class="loginInput">
                <el-input class="borderInput" placeholder="请输入企业名称检索" v-model="searchInfoMyJoin"></el-input>
                <img src="../../assets/image/icon_ss@2x.png" @click="handleJoinSearch" alt />
              </div>
            </div>
            <div class="companyList">
              <ul class="companyList">
                <li v-for="(item,index) in myJoinList" @click="handleItemClick(item)">
                  <div class="topItem">
                    <div class="left">
                      <img v-if="item.company_logo" :src="item.company_logo" alt />
                      <img
                        v-else
                        src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
                        alt
                      />
                      <h3>{{item.company_name}}</h3>
                    </div>
                    <div class="right">
                      <el-button @click="goCompanyHome(item)">进入</el-button>
                    </div>
                  </div>
                  <!-- <div :key="index" v-show="item.isShow">{{item.lale}}</div> -->
                  <div
                    :key="index"
                    class="bottemItem"
                    :class="{'isClickActive':ind === item.company_id}"
                  >{{'企业简介:'+item.content}}</div>
                </li>
              </ul>
            </div>
          </el-tab-pane>
          <!-- 2加入企业 -->
          <el-tab-pane label="加入企业" name="second">
            <div class="searchRow">
              <div class="loginInput">
                <el-input class="borderInput" placeholder="请输入企业名称检索" v-model="searchInfo"></el-input>
                <img src="../../assets/image/icon_ss@2x.png" @click="handleCompanySearch" alt />
              </div>
            </div>
            <ul class="companyList">
              <li v-for="(item,index) in companyList" @click="handleItemClick2(item)">
                <div class="topItem">
                  <div class="left">
                    <img v-if="item.company_logo" :src="item.company_logo" alt />
                    <img
                      v-else
                      src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
                      alt
                    />
                    <h3>{{item.company_name}}</h3>
                  </div>
                  <div class="right">
                    <el-button @click="handleJoinCompany(item)">申请加入</el-button>
                  </div>
                </div>
                <!-- <div :key="index" v-show="item.isShow">{{item.lale}}</div> -->
                <div
                  :key="index"
                  class="bottemItem"
                  :class="{'isClickActive':ind2 === item.company_id}"
                >{{'企业简介:'+item.content}}</div>
              </li>
            </ul>
          </el-tab-pane>
          <el-tab-pane label="创建企业" name="third">
            <div class="creatBox">
              <!-- 3.1企业全称 -->
              <el-row class="creatFormRow">
                <el-col class="leftLable" :span="4">
                  <img src="../../assets/image/icon_gs@2x.png" alt />
                  <span>企业全称</span>
                </el-col>
                <el-col class="rightInput" :span="20">
                  <el-input v-model="creatForm.name"></el-input>
                </el-col>
              </el-row>
              <!-- 3.2企业logo -->
              <el-row class="creatFormRow">
                <el-col class="leftLable" :span="4">
                  <img src="../../assets/image/icon_tp@2x.png" alt />
                  <span>企业logo</span>
                </el-col>
                <el-col class="rightInput upLoadInput" :span="20">
                  <div class="noPic" v-if="!imgUrl">
                    <i class="el-icon-plus"></i>
                  </div>
                  <img :src="imgUrl" v-if="imgUrl" alt style="width:75px;height:75px" />
                  <el-upload class="upload-demo" action="#" :before-upload="handleBefore">
                    <el-button size="small" type="primary">
                      <img src="../../assets/image/icon_sc@2x.png" alt />
                      点击上传文件
                    </el-button>
                  </el-upload>
                </el-col>
              </el-row>
              <!-- 3.3企业简介 -->
              <el-row class="creatFormRow aiTop">
                <el-col class="leftLable" :span="4">
                  <img src="../../assets/image/icon_gs@2x.png" alt />
                  <span>企业简介</span>
                </el-col>
                <el-col class="rightInput" :span="20">
                  <el-input type="textarea" v-model="creatForm.remark"></el-input>
                </el-col>
              </el-row>
              <el-row class="creatFormRow btnRow">
                <el-col class="leftLable" :span="4"></el-col>
                <el-col class="rightInput" :span="20">
                  <el-button type="info" :disabled="isDisable" @click="handleCanel">取消</el-button>
                  <el-button type="primary" @click="handleAddSubmit">提交</el-button>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import JoinHeader from '../../components/JoinHeader'
export default {
  data() {
    return {
      member_id: '',
      token: '',
      activeName: 'first',
      searchInfoMyJoin: '',
      searchInfo: '',
      ind: '',
      ind2: '',
      imgUrl: '',
      creatForm: {
        name: '',
        remark: '',
      },
      companyList: [],
      myJoinList: [],
    }
  },
  methods: {
    goCompanyHome(item) {
      localStorage.setItem('bthl_process_LoginCompanyId', item.company_id)
      localStorage.setItem('bthl_process_LoginCompanyLoGo', item.company_logo)
      localStorage.setItem('bthl_process_LoginCompanyName', item.company_name)
      localStorage.setItem(
        'bthl_process_department_model',
        item.department_model
      )
      this.$router.push({
        path: '/index/home',
        query: {
          department_model: item.department_model,
        },
      })
    },
    // 申请加入企业
    async handleJoinCompany(item) {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', item.company_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Company/apply_to_join',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
    },
    // *创建企业
    async handleAddSubmit() {
      if (this.creatForm.name.trim().length == 0) {
        return this.$message.error('请输入企业名称')
      }
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_name', this.creatForm.name)
      param.append('company_logo', this.imgUrl)
      param.append('content', this.creatForm.remark)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Company/create',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$router.go(0)
      this.$message.success(res.datas.msg)
    },
    // 上传
    async handleBefore(file) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('file', file)
      // return console.log('param', param.get('access_token'))
      const { data: res } = await this.$axios({
        method: 'post',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: '/api/User/uploadImg',
        // data: param,
        data: param,
      })
      // return console.log('res', res)
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success('上传成功')
      this.imgUrl = res.datas.img_url
    },
    // *获取企业列表
    async getCompanyList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('search', this.searchInfo)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Company/search',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      console.log('企业列表res', res)
      this.companyList = res.datas.listInfo
      console.log('企业列表', this.companyList)
    },
    // *获取我加入的企业
    async getMyJoinList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('search', this.searchInfoMyJoin)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Company/index',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.myJoinList = res.datas.listInfo
      console.log('我加入的企业', this.myJoinList)
    },
    // 点击取消
    handleCanel() {
      this.imgUrl = ''
      this.creatForm.remark = ''
      this.creatForm.name = ''
    },
    handleJoinSearch() {
      this.getMyJoinList()
    },
    handleCompanySearch() {
      this.getCompanyList()
    },
    // 点击列表某项显示简介
    handleItemClick(item) {
      if (this.ind == item.company_id) {
        this.ind = ''
      }
      this.ind = item.company_id
      console.log(this.ind)
    },
    handleItemClick2(item) {
      if (this.ind2 == item.company_id) {
        this.ind2 = ''
      }
      this.ind2 = item.company_id
    },
    // 修改tabs下划线长度
    handleClick(tab, event) {
      this.ind = ''
      this.ind2 = ''
      this.searchInfoMyJoin = ''
      this.searchInfo = ''
      if (tab.name == 'first') {
        this.$nextTick(() => {
          let a = document.getElementsByClassName('el-tabs__active-bar')
          a[0].style.marginLeft = '30px'
        })
        this.getMyJoinList()
      } else {
        this.$nextTick(() => {
          let a = document.getElementsByClassName('el-tabs__active-bar')
          a[0].style.marginLeft = '10px'
        })
      }
    },
  },
  created() {
    localStorage.removeItem('bthl_process_LoginCompanyId')
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    console.log('token', this.token)
    this.getMyJoinList()
    this.getCompanyList()
  },
  computed: {
    isDisable() {
      if (
        this.imgUrl != '' ||
        this.creatForm.remark != '' ||
        this.creatForm.name != ''
      ) {
        return false
      } else {
        return true
      }
    },
  },
  components: {
    JoinHeader,
  },
}
</script>
<style lang="less" scoped>
.isClickActive {
  display: block !important;
}
#joinCompany {
  width: 100%;
  height: 100%;
  background-color: #f4f5f6;
}
// 导航栏
.headerRow {
  width: 100%;
  height: 8%;
  box-shadow: 0px 30px 60px 0px rgba(0, 0, 0, 0.04);
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  .left {
    margin-left: 8%;
    img {
      width: 200px;
    }
  }
  .right {
    margin-right: 8%;
    display: flex;
    align-items: center;
    .setting {
      width: 25px;
      height: 25px;
      margin-right: 40px;
    }
    .header {
      width: 48px;
      height: 48px;
      border-radius: 24px;
    }
  }
}

// 创建企业
.creatBox {
  width: 100%;
  padding-top: 20px;
  .aiTop {
    align-items: flex-start !important;
    .leftLable {
      padding-top: 10px;
    }
    /deep/.el-textarea__inner {
      width: 40%;
      height: 250px;
      font-size: 18px;
      resize: none;
      font-family: Microsoft YaHei;
      border-radius: 0;
    }
  }

  // 按钮行
  .btnRow {
    .rightInput {
      display: flex;
    }
    /deep/.el-button--info {
      background-color: #cccccc;
      border-color: #ccc;
    }
    /deep/.el-button {
      // width: 160px;
      width: 14%;
      margin-right: 5%;
      height: 50px;
      padding: 0;
      border-radius: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      font-weight: normal;
    }
  }
  .creatFormRow {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
    .leftLable {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      img {
        width: 20px;
      }
      span {
        font-size: 20px;
        margin-left: 10px;
        color: #333;
      }
    }
    .upLoadInput {
      display: flex;
      align-items: flex-end;
      /deep/.el-button {
        border: none;
        background-color: #fff;
        color: #128bf1;
        font-size: 16px;
        font-weight: normal;
        img {
          width: 19px;
          height: 14px;
        }
      }
    }
    .rightInput {
      padding-left: 40px;
      .noPic {
        width: 76px;
        height: 76px;
        border-radius: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #eceef0;
        i {
          font-size: 40px;
          color: #fff;
          font-weight: 700;
        }
      }
      // 输入框
      /deep/ .el-input__inner {
        font-size: 18px;
        border-radius: 0;
        height: 50px;
        width: 40%;
      }
    }
  }
}
// 主体
.bodyRow {
  height: 92%;
  width: 90%;
  overflow: hidden;
  margin: 0 auto;
  .titleRow {
    display: flex;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 20px;
    img {
      width: 32px;
      height: 29px;
      margin-right: 20px;
    }
    span {
      color: #333;
      font-size: 28px;
    }
  }
  .infoRow {
    box-sizing: border-box;
    width: 100%;
    height: calc(100% - 88px - 30px);
    background-color: #fff;
    border-radius: 10px;
    padding: 20px 40px 30px;
    .searchRow {
      margin-bottom: 30px;
    }
    // 滚动条
    /deep/.el-tabs {
      height: 100%;
      .el-tabs__content {
        height: calc(100% - 90px);
        .el-tab-pane {
          height: 100%;
        }
      }
    }

    // 企业列表
    .companyList {
      height: calc(100% - 70px);
      overflow-y: auto;
      width: 100%;
      ul {
        height: 100%;
      }
      li:nth-child(odd) {
        background-color: #f4f5f6;
      }
      li {
        border: 1px solid #f4f5f6;
        cursor: pointer;
        box-sizing: border-box;
        width: 100%;
        padding: 30px;
        .topItem {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .bottemItem {
          display: none;
          width: 50%;
          font-size: 14px;
          color: #999;
          margin-left: 75px;
          margin-top: 5px;
        }
        .left {
          display: flex;
          align-items: center;
          img {
            width: 50px;
            height: 50px;
            border-radius: 25px;
            margin-right: 24px;
          }
          h3 {
            color: #333333;
            font-size: 20px;
            font-weight: normal;
          }
        }
        .right {
          /deep/.el-button {
            padding: 12px 25px;
            font-size: 16px;
            color: #0099ff;
            border-color: #0099ff;
          }
        }
      }
    }
  }
}

// 修改tabs样式
/deep/.el-tabs__active-bar {
  width: 68px !important;
  margin-left: 30px;
}
/deep/.el-tabs {
  width: 100%;
  .el-tabs__header {
    width: 100%;
    margin-bottom: 30px;
    .el-tabs__nav-wrap {
      width: 100%;
      .el-tabs__nav-scroll {
        width: 100%;
        .el-tabs__nav {
          width: 100%;
        }
      }
    }
  }
}
/deep/.el-tabs__item {
  height: 60px;
  text-align: center;
  font-size: 22px;
  color: #999999;
  font-weight: 400;
  padding-right: 100px;
  // width: 17%;
}
/deep/.el-tabs__item.is-active {
  color: #333 !important;
}
/deep/.el-tabs__item:hover {
  color: #333 !important;
}
/deep/.el-tabs__nav-wrap::after {
  color: #999999;
}

// 修改input
.borderInput /deep/.el-input__inner {
  background-color: rgba(255, 255, 255, 0);
  outline: none;
  border-radius: 0;
  padding-left: 30px;
  font-size: 16px;
  height: 40px;
  border-radius: 20px;
}
// 登录输入框
.loginInput {
  width: 400px;
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  img {
    position: absolute;
    right: 20px;
    z-index: 2;
    width: 22px;
    height: 22px;
  }
}

.companyList::-webkit-scrollbar {
  width: 5px !important;
}
.companyList::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
.companyList::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}
</style>